import { atom } from 'recoil';

export const tempTopLoadingBar = atom({
  key: 'tempTopLoadingBar',
  default: { type: 'success', progress: 0, hideOnCompletion: true },
});
